import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Icon from './Icon';
import '../css/sort-menu.css';

// Мультивыбор в стиле CustomSelect: пустой массив = «все значения».
const MultiSelect = ({
  values = [],
  options,
  onChange,
  allLabel,
  allIcon = 'layers',
  summaryLabel,
  minWidth = '160px',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const toggle = (value) => {
    const next = values.includes(value)
      ? values.filter((v) => v !== value)
      : [...values, value];
    onChange(next);
  };

  const selectedOptions = options.filter((opt) => values.includes(opt.value));
  const isEmpty = selectedOptions.length === 0;

  let buttonLabel = allLabel;
  let buttonIcon = allIcon;
  if (selectedOptions.length === 1) {
    buttonLabel = selectedOptions[0].label;
    buttonIcon = selectedOptions[0].icon || allIcon;
  } else if (selectedOptions.length > 1) {
    buttonLabel = summaryLabel ? summaryLabel(selectedOptions.length) : `${selectedOptions.length}`;
  }

  const isPercentWidth = typeof minWidth === 'string' && minWidth.includes('%');

  return (
    <div className="sort-menu-wrapper" ref={containerRef}>
      <button
        type="button"
        className={`sort-menu-button${isEmpty ? '' : ' filter-active'}`}
        onClick={() => setIsOpen(!isOpen)}
        style={{ minWidth, width: isPercentWidth ? minWidth : undefined, justifyContent: 'space-between' }}
      >
        <span className="sort-menu-label" style={{ textAlign: 'left', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Icon name={buttonIcon} size={16} />
          {buttonLabel}
        </span>
        <span className="sort-menu-arrow">
          <Icon name="chevron-down" size={12} className={`expand-icon ${isOpen ? 'open' : ''}`} />
        </span>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="sort-menu-dropdown"
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 4 }}
            transition={{ duration: 0.15, ease: 'easeOut' }}
            style={{ minWidth: '100%', maxWidth: 'min(320px, calc(100vw - 2rem))', padding: '8px', left: 0, right: 'auto', zIndex: 1000 }}
          >
            <div className="sort-menu-options" style={{ gap: '6px' }}>
              <button
                type="button"
                className={`sort-menu-option ${isEmpty ? 'active' : ''}`}
                onClick={() => onChange([])}
                style={{
                  justifyContent: 'flex-start',
                  padding: '10px 12px',
                  border: '1px solid var(--border-color)',
                  background: isEmpty ? 'var(--nav-active-bg, rgba(59, 130, 246, 0.05))' : 'var(--bg-secondary)',
                  minWidth: 0,
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <Icon name={allIcon} size={16} style={{ opacity: 0.8 }} />
                  <span className="sort-menu-option-label" style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{allLabel}</span>
                </div>
                {isEmpty && (
                  <span className="sort-menu-option-check" style={{ marginLeft: '12px' }}>
                    <Icon name="check" size={14} />
                  </span>
                )}
              </button>

              {options.map((option) => {
                const checked = values.includes(option.value);
                return (
                  <button
                    key={option.value}
                    type="button"
                    className={`sort-menu-option ${checked ? 'active' : ''}`}
                    onClick={() => toggle(option.value)}
                    style={{
                      justifyContent: 'flex-start',
                      padding: '10px 12px',
                      border: '1px solid var(--border-color)',
                      background: checked ? 'var(--nav-active-bg, rgba(59, 130, 246, 0.05))' : 'var(--bg-secondary)',
                      minWidth: 0,
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span className={`multi-select-box${checked ? ' checked' : ''}`}>
                        {checked && <Icon name="check" size={12} />}
                      </span>
                      {option.icon && <Icon name={option.icon} size={16} style={{ opacity: 0.8 }} />}
                      <span className="sort-menu-option-label" style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{option.label}</span>
                    </div>
                  </button>
                );
              })}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MultiSelect;
